interface BreadcrumbEntry {
  label: string;
  href?: string;
  isActive?: boolean;
}

interface CurrentClientShape {
  id?: string | number;
  name?: string;
  [key: string]: unknown;
}

export const getBreadcrumbsForProduct = (
  currentClient: CurrentClientShape | null | undefined,
  productName: string,
): BreadcrumbEntry[] => {
  const baseBreadcrumbs: BreadcrumbEntry[] = [
    { label: 'Clients', href: '/admin/clients' },
    {
      label: currentClient?.name ?? '',
      href: `/admin/clients/${currentClient?.id}`,
    },
    {
      label: 'Products',
      href: `/admin/clients/${currentClient?.id}/products`,
    },
    {
      label: productName,
      isActive: true,
    },
  ];

  return baseBreadcrumbs;
};
